import { render, staticRenderFns } from "./interestTransfer.vue?vue&type=template&id=521f9be0&scoped=true&"
import script from "./interestTransfer.vue?vue&type=script&lang=js&"
export * from "./interestTransfer.vue?vue&type=script&lang=js&"
import style0 from "./interestTransfer.vue?vue&type=style&index=0&id=521f9be0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f9be0",
  null
  
)

export default component.exports